import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IBrandResponse, IBrandState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowBrand = createAsyncThunk('listBrands/fetchShowBrand', async (id: string, { rejectWithValue }) => {
  try {
    const response = await adminApiClient.getBrand(id)
    return response.data
  } catch (error: any) {
    if (!error.response) {
      throw error
    }

    return rejectWithValue(error)
  }
})

const initialState: IBrandState = {
  isLoading: false,
  response: null,
  error: null
}

const showBrandSlice = createSlice({
  name: 'brands/show',
  initialState,
  reducers: {
    resetShowBrand: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowBrand.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowBrand.fulfilled, (state, action: PayloadAction<IBrandResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowBrand.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showBrandSlice.reducer
export const { resetShowBrand } = showBrandSlice.actions
